import * as React from 'react';
import { IItemsViewLayoutHandler, itemsViewLayoutHandlerControl, IItemsViewLayoutProps } from '../../../controls/itemsViewBetaControl';
import { Facet } from '../../../models/Facet';
import { IItemCache } from '../../../models/IItemCacheObserver';
import { withPageLoadTracker } from '../../decorators/withPageLoadTracker';
import { childItemsFacet } from '../../../facets/SetFacets';
import { EmptyFolder } from '../../itemsEmptyFolder/EmptyFolder';

const PageLoadEmptyFolder = withPageLoadTracker([childItemsFacet])(EmptyFolder);

class LayoutEmptyFolder extends React.PureComponent<IItemsViewLayoutProps> {
  public render(): JSX.Element | null {
    const {
      itemKey
    } = this.props;

    return itemKey ? (
      <PageLoadEmptyFolder itemKey={ itemKey } />
    ) : null;
  }
}

export const itemsViewEmptyLayoutHandler: IItemsViewLayoutHandler = {
  key: new Facet('itemsViewEmptyLayout').id,
  command: {}, // This layout should not appear as a command.
  controlHandler: (
    itemCache: IItemCache,
    props: typeof itemsViewLayoutHandlerControl.inputType
  ): typeof itemsViewLayoutHandlerControl.returnType => {
    const {
      itemKey
    } = props;

    const childItems = itemCache.isItemFacetResolved(childItemsFacet, itemKey) ?
      itemCache.demandItemFacet(childItemsFacet, itemKey) :
      undefined;

    const isEmpty = !!childItems && !!childItems.itemKeys && childItems.itemKeys.length === 0;

    if (!isEmpty) {
      return {};
    }

    return {
      layout: LayoutEmptyFolder
    };
  }
};
